import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.45h-.212L4.924 3.513S2.38 5.24 2.484 8.698c.106 3.456 3.395 4.968 3.395 4.968H2.697S1 12.37 1 8.698C1 3.512 5.666 2 5.666 2L8 10.426 10.334 2S15 3.512 15 8.697c0 3.673-1.697 4.97-1.697 4.97h-3.182s3.287-1.513 3.395-4.97c.105-3.457-2.44-5.185-2.44-5.185L8.212 13.45H8Z",
    fill: "currentColor"
  }));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { MetroSpb16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */
export var MetroSpb16 = createIcon(IconComponent);